import { ButtonBase, Typography, useTheme } from "@mui/material";
import { type LucideIcon, Plus } from "lucide-react";
import type { FC } from "react";

const MIN_HEIGHT = 48;

type Props = {
	label: string;
	onClick: () => void;
	icon?: LucideIcon;
	divider?: boolean;
};

export const InspirationAddButton: FC<Props> = ({
	label,
	onClick,
	icon: Icon = Plus,
	divider = false,
}) => {
	const theme = useTheme();

	return (
		<ButtonBase
			onClick={onClick}
			sx={{
				width: "100%",
				minHeight: MIN_HEIGHT,
				justifyContent: "flex-start",
				gap: theme.spacingTokens.sm,
				textAlign: "left",
				borderTop: divider
					? theme.colors.border.solid(theme.palette.grey[200])
					: undefined,
				"&:active": { bgcolor: theme.palette.grey[50] },
			}}
		>
			<Icon size={theme.iconSize.sm} color={theme.palette.blue.main} />
			<Typography variant="bodyMedium" color={theme.palette.blue.main}>
				{label}
			</Typography>
		</ButtonBase>
	);
};
